import { useCallback } from 'react';

import { cx } from '@libs/classnames';
import { Card } from '@ui/components/Card';
import { Popover } from '@ui/components/Popover';

import styles from '../TournamentParticipantsEdit.module.css';

export type TeamOptionType = {
  teamId: string;
  name: string;
  disabled?: boolean;
};

type Props = {
  isOpen: boolean;
  hide?: () => void;
  teamOptions: TeamOptionType[];
  value: string | null;
  onChange: (teamId: string | null) => void;
};
export function SelectTeamPopover({ isOpen, hide, teamOptions, value, onChange }: Props) {
  const onSelectNoTeam = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return (
    <Popover
      // FIXME: отвязать попап от кнопки (через портал), чтобы иметь плавные анимации скрытия
      // даже при перемещении кнопки в новое место
      className={styles.selectTeamPopover}
      wrapperClassName={styles.selectTeamPopoverWrapper}
      onHide={hide}
      active={isOpen}
    >
      <Card className={styles.content}>
        <div className={styles.title}>Переместить в команду</div>

        <div className={styles.teams}>
          <TeamOption
            key="no-team"
            id=""
            name="Без команды"
            onClick={onSelectNoTeam}
            disabled={!value}
          />

          {teamOptions?.map((o) => (
            <TeamOption
              key={o.teamId}
              id={o.teamId}
              name={o.name}
              onClick={onChange}
              disabled={o.disabled || value === o.teamId}
            />
          ))}

          {!teamOptions || (!teamOptions.length && 'Нет команд')}
        </div>

        <hr className={styles.hr} />

        <div className={styles.cancel} onClick={hide}>
          Отмена
        </div>
      </Card>
    </Popover>
  );
}

type TeamOptionProps = {
  id: string;
  name: string;
  onClick: (teamId: string) => void;
  disabled?: boolean;
};
function TeamOption({ id, name, onClick, disabled }: TeamOptionProps) {
  const handleClick = useCallback(() => {
    onClick(id);
  }, [onClick, id]);

  return (
    <div className={cx(styles.teamOption, { [styles.disabled]: disabled })} onClick={handleClick}>
      {name}
    </div>
  );
}
